export const CLEAR_PDF_LIST = 'CLEAR_PDF_LIST'
export const ADD_PDF_TO_LIST = 'ADD_PDF_TO_LIST'
export const REMOVE_PDF_FROM_LIST = 'REMOVE_PDF_FROM_LIST'
export const SET_REPORT_WINDOW_INSTANCE = 'SET_REPORT_WINDOW_INSTANCE'
export const REFRESH_PDF_LIST = 'REFRESH_PDF_LIST'
export const SET_R_V_REQUEST_OPEN = 'SET_R_V_REQUEST_OPEN'
// export const CLEAR_WINDOW_INSTANCE = 'CLEAR_WINDOW_INSTANCE';

export const pdfTypes = {
  RECEIPT: 'RECEIPT',
  CORRESPONDENCE: 'CORRESPONDENCE',
  BUSINESS_ENTITY: 'BUSINESS_ENTITY',
  TRADEMARK: 'TRADEMARK',
  BATCH_REPORT: 'BATCH_REPORT',
  DISTRIBUTION_REPORT: 'DISTRIBUTION_REPORT',
  RECONCILE_REPORT: 'RECONCILE_REPORT',
  UCC1: 'UCC1',
  ORDER: 'ORDER',
  NOTARY: 'NOTARY',
  APOSTILLE: 'APOSTILLE',
  FACSIMILE: 'FACSIMILE',
  REGISTERED_AGENT: 'REGISTERED_AGENT',
  SERVICE_OF_PROCESS: 'SERVICE_OF_PROCESS',
  IMAGE_ENVELOPE: 'IMAGE_ENVELOPE'
}

const initialState = {
  refreshFlag: false,
  requestOpen: false,
}

const ReportViewerReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_PDF_LIST:
      localStorage.setItem('REPORTS_LIST', JSON.stringify([]))
      return { ...initialState, refreshFlag: true }
    case ADD_PDF_TO_LIST: {
      const pdfList = JSON.parse(localStorage.getItem('REPORTS_LIST')) || []
      const pdfInfo = { ...action.pdfInfo, reportDate: new Date() }
      const found = pdfList.find((pdf) => pdf.filename === action.pdfInfo.filename)
      let updatedList = []
      if (!found) {
        updatedList = [pdfInfo, ...pdfList]
      } else {
        updatedList = [
          ...pdfList.map((pdf) => {
            if (pdf.filename === pdfInfo.filename) {
              return {
                ...pdfInfo,
                requery: true,
              }
            }
            return pdf
          }),
        ]
      }
      // console.log("updatedList: ", updatedList)
      localStorage.setItem('REPORTS_LIST', JSON.stringify(updatedList))
      return { ...state, refreshFlag: true, requestOpen: true }
    }
    case REMOVE_PDF_FROM_LIST: {
      return {
        ...state,
        pdfList: state.pdfList.filter((info) => {
          return info.type !== action.pdfType || info.filename !== action.filename
        }),
        refreshFlag: true,
      }
    }
    case SET_REPORT_WINDOW_INSTANCE: {
      return {
        ...state,
        windowInstance: action.windowInstance,
      }
    }
    // case CLEAR_WINDOW_INSTANCE: {
    //   return {
    //     ...state,
    //     windowInstance: null
    //   }
    // }
    case REFRESH_PDF_LIST: {
      return {
        ...state,
        refreshFlag: false,
      }
    }
    case SET_R_V_REQUEST_OPEN: {
      return {
        ...state,
        requestOpen: action.requestOpen,
      }
    }
    default:
      return state
  }
}

export default ReportViewerReducer
